export const CUSTOM_ORDER_VARIATION_ID = '__custom_order__'
export const CUSTOM_ORDER_VARIATION_NAME = 'Нестандартный заказ'
